import OverlayThumb from './OverlayThumb';

export default OverlayThumb;
